export function gaspScrolltrigger() {


    const wrapper = document.querySelector(".js-wrapper");
    if (wrapper) {
        //読み込み
        gsap.registerPlugin(ScrollTrigger);
        //
        ScrollTrigger.normalizeScroll(true);

        //アニメーションエリア
        const trigger = document.querySelector('.js-wrapper');

        //pin
        const tl = gsap.timeline({
            scrollTrigger: {
            trigger: trigger,
            start: "top top",
            end: () => `+=${window.innerHeight * 3}`,
            //markers: true,
            scrub: true,
            pin: true,
            invalidateOnRefresh: true // これでリフレッシュ時にendを再計算
            }
        });

        tl
        .to(".p-indexService_listItem._01",{delay: 8, autoAlpha: 0, duration: 4, ease: "power2.out" }, ">")
        .to(".p-indexService_listItem._02",{delay: 8, autoAlpha: 0, duration: 4, ease: "power2.out" }, ">")
        .to(".p-indexService_listItem._03",{delay: 8, autoAlpha: 0, duration: 4, ease: "power2.out" }, ">")
    }


    
    const recruitAnime = document.querySelector(".js-recruitAnime");
    if (recruitAnime) {
        //読み込み
        gsap.registerPlugin(ScrollTrigger);
        //
        ScrollTrigger.normalizeScroll(true);

        //アニメーションエリア
        const trigger = document.querySelector('.js-recruitAnime');

        //pin
        const tl = gsap.timeline({
            scrollTrigger: {
            trigger: trigger,
            start: "top top",
            end: () => `+=${window.innerHeight * 2}`,
            //markers: true,
            scrub: true,
            pin: true,
            invalidateOnRefresh: true // これでリフレッシュ時にendを再計算
            }
        });

        tl
        .set(".p-recruitPin_listItem._02", {autoAlpha: 0})
        .to(".p-recruitPin_listItem._01",{delay: 8, autoAlpha: 0, duration: 3, ease: "power2.out" }, ">")
        .to(".p-recruitPin_listItem._02",{ autoAlpha: 1, duration: 3, ease: "power2.out" }, "<")
    }

    const interviewContBox = document.querySelector(".p-interviewCont_box_R");
    const parentBox = document.querySelector(".p-interviewCont_box");

    if (interviewContBox && parentBox) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.normalizeScroll(true);

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: interviewContBox,
                start: "top top",
                endTrigger: parentBox,  // end は親要素の位置で判定
                end: "bottom bottom",   // 親の bottom が viewport の bottom に到達時解除
                scrub: true,
                pin: true,
                invalidateOnRefresh: true,
                //markers: true,
            }
        });

        tl
        .set(".p-interviewCont_box_img._02", {autoAlpha: 0})
        .set(".p-interviewCont_box_img._03", {autoAlpha: 0})
        .to(".p-interviewCont_box_img._01",{delay: 8, autoAlpha: 0, duration: 3, ease: "power2.out" }, ">")
        .to(".p-interviewCont_box_img._02",{ autoAlpha: 1, duration: 3, ease: "power2.out" }, "<")
        .to(".p-interviewCont_box_img._02",{delay: 8, autoAlpha: 0, duration: 3, ease: "power2.out" }, ">")
        .to(".p-interviewCont_box_img._03",{ autoAlpha: 1, duration: 3, ease: "power2.out" }, "<")
    }




    //■■■■■■■■■■■■■■■■■■■■■■■■■■■


    const triggerEl_A = document.querySelector(".p-fukuriList_area");
    if (triggerEl_A) {
        const triggerHeight = triggerEl_A.offsetHeight;
        const moveDistance = (triggerHeight * 2) / 10;  // 要素の高さに対する移動距離

        gsap.utils.toArray(".circle_A").forEach(scrollItem_02 => {
            gsap.fromTo(scrollItem_02, {
                y: 0,
            }, {
                y: moveDistance,
                ease: "none",
                scrollTrigger: {
                    trigger: ".p-fukuriList_area",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    //invalidateOnRefresh: true,//リサイズ再計算
                },
            });
        });
    }

    const triggerEl_B = document.querySelector(".p-fukuriList_area");
    if (triggerEl_B) {
        const triggerHeight = triggerEl_B.offsetHeight;
        const moveDistance = (triggerHeight * 4) / 10;  // 要素の高さに対する移動距離

        gsap.utils.toArray(".circle_B").forEach(scrollItem_02 => {
            gsap.fromTo(scrollItem_02, {
                y: 0,
            }, {
                y: moveDistance,
                ease: "none",
                scrollTrigger: {
                    trigger: ".p-fukuriList_area",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    //invalidateOnRefresh: true,//リサイズ再計算
                },
            });
        });
    }

}
